import * as Sentry from "@sentry/react";
import { getAuth } from "firebase/auth";
import { BACKEND_URL } from "src/constants";
import {
  DefaultParameterVisit,
  StrategyDashboardNotification,
} from "store/api/generatedApi";

export const sendVisitNotification = async ({
  path,
  visit,
}: {
  path: string;
  visit:
    | Omit<DefaultParameterVisit, "replay_id">
    | Omit<StrategyDashboardNotification, "replay_id">;
}) => {
  try {
    const replay = Sentry.getReplay();
    // Flushing persists buffered recordings and makes replay links available.
    const [token] = await Promise.all([
      getAuth().currentUser?.getIdToken(),
      replay?.flush().catch((error: unknown) => Sentry.captureException(error)),
    ]);
    if (token === undefined) return;
    const response = await fetch(
      `${BACKEND_URL.replace(/\/$/, "")}/api/v2/${path}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...visit,
          replay_id: replay?.getReplayId() ?? null,
        }),
        keepalive: true,
        signal: AbortSignal.timeout(10000),
      }
    );
    if (!response.ok) {
      throw new Error(`Visit notification failed: ${response.status}`);
    }
  } catch (error) {
    Sentry.captureException(error);
  }
};
